import React from 'react';
import { useIntl } from 'react-intl';

import Breadcrumb from '~components/breadcrumbs';

// Visible breadcrumb for city pages. Mirrors the BreadcrumbList JSON-LD
// (Home -> City) emitted server-side in generateStructuredData, so the
// rendered trail and the structured data stay in sync: same labels, same hrefs.
const Breadcrumbs = ({ city, slug }) => {
  const intl = useIntl();

  if (!city) return null;

  return (
    <aside className="c-subheader">
      <div className="l-container">
        <Breadcrumb.Wrapper className="c-breadcrumb--force-wrap">
          <Breadcrumb.Crumb>
            <Breadcrumb.CrumbLink to="/" index={1}>
              {intl.formatMessage({
                id: 'containers.city.seo.schema.breadcrumb.home',
                defaultMessage: 'Home',
              })}
            </Breadcrumb.CrumbLink>
          </Breadcrumb.Crumb>
          <Breadcrumb.Crumb>
            <Breadcrumb.CrumbLink to={`/${slug}`} index={2}>
              {city}
            </Breadcrumb.CrumbLink>
          </Breadcrumb.Crumb>
        </Breadcrumb.Wrapper>
      </div>
    </aside>
  );
};

export default Breadcrumbs;
